import { type DataQuery, type DataSourceRef } from '@grafana/schema';

type User = {
  uid: string;
  displayName?: string;
  avatarUrl?: string;
};

export type OnSelectQueryType = (query: DataQuery, title?: string) => void;

// Multi-query selection (e.g. a recent-queries entry that ran several queries together).
export type OnSelectQueriesType = (queries: DataQuery[], title?: string) => void;

export type QueryLibraryEventsPropertyMap = Record<string, string | number | boolean | undefined>;

// flattened data from API response to facilitate structs
export type SavedQueryBase = {
  uid: string;
  title: string;
  description: string;
  tags: string[];
  isLocked: boolean;
  isVisible: boolean;
  createdAtTimestamp: number;
  user: User;
  targets: DataQuery[];
};
// this should actually be like this, but not posssible due to enterprise Spec
// & Required<Pick<QuerySpec, 'title' | 'description' | 'tags' | 'isLocked' | 'isVisible'>>;

// our model of SavedQuery to use throughout the frontend
export type SavedQuery = {
  query: DataQuery;
  datasourceName?: string;
  queryText?: string;
  datasourceRef?: DataSourceRef | null;
  datasourceType?: string;
  // Set when metadata enrichment failed for this row (e.g. its datasource was deleted).
  // The row is still surfaced so the user can see and delete it, but its datasource-derived
  // fields are absent and edit/select are disabled.
  loadError?: Error;
} & Omit<Partial<SavedQueryBase>, 'targets'>;

export enum QueryLibraryTab {
  ALL = 'all',
  FAVORITES = 'favorites',
  RECENT = 'history',
  FEEDBACK = 'feedback',
}
